module.exports = __webpack_public_path__ + "img/数据导入.1ed2aa13.svg";